import React from 'react';
import PropTypes from 'prop-types';
import PageContent from '../../components/Page/components/PageContent';

/**
 * A component that renders the access denied page
 */
export default function Error({ message }) {
  return (
    <PageContent title="Errore">
      <h3>{message || 'Impossibile contattare il server. Riprovare.'}</h3>
    </PageContent>
  );
}

Error.propTypes = {
  message: PropTypes.node,
};

Error.defaultProps = {
  message: undefined,
};
